import React from 'react';
import { Select, Button, Space } from 'antd';
import { SettingOutlined, LayoutOutlined } from '@ant-design/icons';
import { LAYOUTS } from '../../utils/multiWindowLive';
import ResourceManager from './ResourceManager';

const { Option } = Select;

/**
 * 多窗口直播页顶栏：布局切换 / 自动填充 / 清空 / 设置 / 资源占用提示
 */
export default function MultiWindowHeader({
  currentLayout,
  setCurrentLayout,
  availableStreams,
  streams,
  resourceUsage,
  isPageVisible,
  pageHiddenTime,
  autoFillStreams,
  clearAllStreams,
  onOpenSettings
}) {
  return (
    <div className="page-header">
      <div className="header-left">
        <h1>多窗口直播回传系统</h1>
        <div className="stream-count">
          活跃流: {availableStreams.length} | 当前窗口: {streams.filter(s => s !== null).length}/{streams.length} | 播放设备: {resourceUsage.active}/{resourceUsage.max}
          <span style={{ marginLeft: 8, color: '#8c8c8c' }}>按住画面拖动可换窗 · 双击全屏</span>
          {ResourceManager.pendingCleanup.size > 0 && (
            <span style={{ color: '#faad14', marginLeft: '8px' }}>
              (清理中: {ResourceManager.pendingCleanup.size})
            </span>
          )}
          {!isPageVisible && (
            <span style={{ color: '#ff4d4f', marginLeft: '8px' }}>
              ⚠️ 页面不可见 - {pageHiddenTime ? Math.floor((Date.now() - pageHiddenTime) / 1000 / 60) : 0}分钟
            </span>
          )}
        </div>
      </div>

      <div className="header-right">
        <Space>
          <Select
            value={currentLayout}
            onChange={setCurrentLayout}
            style={{ width: 150 }}
            dropdownMatchSelectWidth={200}
          >
            {Object.entries(LAYOUTS).map(([key, config]) => (
              <Option key={key} value={key}>
                <LayoutOutlined /> {config.name}
                {config.mode === 'areas' ? ' ·自定义' : ''}
              </Option>
            ))}
          </Select>

          <Button onClick={autoFillStreams} disabled={availableStreams.length === 0}>
            自动填充
          </Button>

          <Button onClick={clearAllStreams} danger>
            清空
          </Button>

          <Button
            icon={<SettingOutlined />}
            onClick={onOpenSettings}
          >
            设置
          </Button>
        </Space>
      </div>
    </div>
  );
}
